import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  showContact: boolean = false;
  firstLoad: boolean = true;
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToAbout() {
    window.scrollTo(500, 100);
    console.log(window);
  }

  hideOrShowContact(): void{
    this.firstLoad = false;
    this.showContact = !this.showContact;
    // await this.router.navigate(['/about']);
  }

}
